import ModusServiceModel from "../ModusServiceModel";
import ResultNutrientRecommendationModel from "./ResultNutrientRecommendationModel";

export default class ResultNutrientRecommendationElementModel extends ModusServiceModel {
  modelName() {
    return 'result-nutrient-recommendation-elements';
  }
  icon() {
    return 'atom';
  }
  defaults() {
    return {
      id: null,
      result_nutrient_recommendation_id: null,
      result_nutrient_recommendation: null,
      element: null,
      value: null,
      unit: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_nutrient_recommendation_id: (val) => (this.nullStringMutator(val)),
      element: (val) => (this.nullStringMutator(val)),
      value: (val) => (this.nullStringMutator(val)),
      unit: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val))
    }
  }
  validation() {
    return {}
  }
  getResultNutrientRecommendation() {
    return this.getRelatedModel(ResultNutrientRecommendationModel, 'result_nutrient_recommendation');
  }
}
